export const textObj = {
  activity:{
    //活动开头文案
    words:[
      "春天是大自然的开始，万物苏醒，绿色和花朵重新点缀了世界。“三八” 国际妇女节即将到来 ，当代女性也如同春天一样，展现出勇敢、坚韧、美丽、智慧的一面。她们是家庭的温柔守护者，也是新时代的建设者，承载了生命的重量和希望，散发着独特的魅力。而春天的气息也让人们感受到了生命的生生不息，让我们一起走出去，感受春天的气息。",
      "图书馆联合“书香中国”全民阅读平台诚邀您参与“三八”妇女节摄影作品征集活动，您可以通过镜头捕捉生活中的美好瞬间，记录内心的感悟和成长。同时，活动也将向社会传递积极的女性形象和价值观念，鼓励更多女性勇敢地表达自己、追求梦想，为平等和包容的社会环境贡献力量。"
    ],
    //活动二维码
    codeImg:require("../img/m/activity/code.jpg"),
    //活动跳转地址
    linkUrl:"https://www.wjx.top/vm/h4EggtD.aspx",
    prizes:[
      {name:'华为手环',level:"一等奖",img:require("../img/common/prize1.png"),num:'1名'},
      {name:'充电宝',level:"二等奖",img:require("../img/common/prize2.png"),num:'3名'},
      {name:'无火香熏',level:"三等奖",img:require("../img/common/prize3.png"),num:'6名'}
    ],
    rules:[
      {title:"一、活动时间",value:"2024年3月8日至2024年3月22日"},
      {title:"二、活动对象",value:"西安明德理工学院全体师生"},
      {title:"三、活动规则",
      value:
      "<p class=\"title2-value\">1.用户可通过活动页面入口或推文进入投稿页面，参与摄影作品活动。 </p>"
      +"<p class=\"title2-value\">2.投稿方式：参与者需进入活动界面，以附件形式上传投稿作品。参赛作品须与主题相关，可以包括但不限于喜爱的书籍、盛开的花朵、美好的春日风景等温馨瞬间合影。在上传作品时，可简要介绍作品并附上一句对自己的祝福。 </p>"
      +"<p class=\"title2-value\">3.参赛摄影作品需提供JPG或PNG格式电子文件，成功提交的作品将视为作品原件。 </p>"
      +"<p class=\"title2-value\">4.所有参赛作品必须为作者的原创作品，不得存在版权争议。如作品涉及肖像权、名誉权、隐私权、著作权、商标权等引发法律纠纷，责任均由作者承担，与主办方无关。主办方保留取消侵权作品参赛资格的权利。 </p>"
      +"<p class=\"title2-value\">5.主办单位有权在非营利性活动中（如：公益展览、内部学术交流等）使用参赛作品，不再付作者稿酬。 </p>"
      +"<p class=\"title2-value\">6.本次活动不收报名费，所有参赛作品均不退稿。 </p>"
      +"<p class=\"title2-value\">7.不符合比赛要求的作品，包括与活动主题不符、思想内容不健康等作品，将被取消参赛资格。</p>"
      +"<p class=\"title2-value\">8.活动截止后,评委将对作品进行评选,在图书馆公众号公布获奖名单并说明领奖方式。</p>"
  },
    ]
  }
}
